// 📁 src/services/chatService.ts
import { Constantes } from "../constants/constantsGlobal";
import {
  RequestConversation,
  RequestConversationCreate,
  RequestConversationUpdate,
} from "../models/interfaceConversation";
import { iResponse } from "../models/interfaceResponse";
import { getAuth } from "firebase/auth";
import setupInterceptor from "./setupInterceptor";

interface FetchOptions extends RequestInit {
  headers?: HeadersInit;
}

/**
 * Helper principal para consumir API con interceptor Firebase
 */
async function apiFetch<T>(
  url: string,
  method: "GET" | "POST" | "PUT",
  user: any,
  setUser: (user: any) => void,
  body?: any
): Promise<iResponse> {
  const options: FetchOptions = {
    method,
    headers: {
      "Content-Type": "application/json",
      //token: Constantes.HEADER_CHAT_BOT_TOKEN,
    },
    body: body ? JSON.stringify(body) : undefined,
  };

  const response = await setupInterceptor(url, user, setUser, options);

  if (!response.ok) {
    throw new Error(`Error en API: ${response.statusText}`);
  }

  return response.json();
}

/**
 * Crear conversación
 */
export async function createConversation(
  request: RequestConversationCreate,
  user: any,
  setUser: (user: any) => void
): Promise<iResponse> {
  return apiFetch(`${Constantes.URI_ChatbotConversation}`, "POST", user, setUser, request);
}

/**
 * Listar conversaciones
 */
export async function listConversations(
  request: RequestConversation,
  user: any,
  setUser: (user: any) => void
): Promise<iResponse> {
  return apiFetch(`${Constantes.URI_ChatbotConversation}/search`, "POST", user, setUser, request);
}

/**
 * Actualizar conversación
 */
export async function updateConversation(
  conversation_id: string,
  request: RequestConversationUpdate,
  user: any,
  setUser: (user: any) => void
): Promise<iResponse> {
  return apiFetch(`${Constantes.URI_ChatbotConversation}/${conversation_id}`, "POST", user, setUser, request);
}

/**
 * Cerrar conversación
 */
export async function closeConversation(
  request: RequestConversationUpdate,
  user: any,
  setUser: (user: any) => void
): Promise<iResponse> {
  return apiFetch(
    `${Constantes.URI_ChatbotConversation}/${request.conversation_id}/close`,
    "POST",
    user,
    setUser,
    request
  );
}

/**
 * Listar mensajes
 */
export async function listMessages(
  request: RequestConversationUpdate,
  user: any,
  setUser: (user: any) => void
): Promise<iResponse> {
  return apiFetch(
    `${Constantes.URI_ChatbotConversation}/${request.conversation_id}/messages`,
    "POST",
    user,
    setUser,
    request
  );
}
